<div
  bsModal
  #modalRef="bs-modal"
  class="modal fade custom-modal"
  tabindex="-1"
  role="dialog"
  [config]="{ backdrop: true }">
  <div class="modal-dialog modal-lg">
    <div class="modal-loader" *ngIf="loading">
      <div class="loader"></div>
    </div>
    <div class="modal-content">
      <div class="modal-header">
        <span>Share Gallery Link</span>
        <img src="assets/img/x.svg" (click)="closeModal()" alt="" />
      </div>
      <div class="modal-body">
        <p class="instruction-text">Choose which version of the gallery link you'd like to copy and share.</p>

        <!-- With Markups/Flags Option -->
        <div class="link-option">
          <div class="link-option-header">
            <label class="link-label"><span style="color: red; font-weight: bold">With</span> markups/flags</label>
            <div class="toggle-container">
              <span class="toggle-label">OFF</span>
              <label class="toggle-switch">
                <input
                  type="checkbox"
                  (change)="updateWithMarkupsToken()"
                  [(ngModel)]="withMarkupsEnabled"
                  [disabled]="processingWithMarkups || loading" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">ON</span>
            </div>
          </div>
          <div class="link-input-container">
            <input
              type="text"
              class="link-input"
              [value]="getWithMarkupsUrl()"
              placeholder="https://gallery_with_markups/flags.com"
              [disabled]="!withMarkupsEnabled"
              readonly
              (click)="withMarkupsEnabled && copyToClipboard(getWithMarkupsUrl(), 'with')" />
            <button
              type="button"
              class="copy-button"
              (click)="copyToClipboard(getWithMarkupsUrl(), 'with'); $event.stopPropagation(); $event.preventDefault()"
              [disabled]="!withMarkupsEnabled">
              <img src="assets/img/svg/link.svg" alt="Copy" />
            </button>
          </div>
        </div>

        <!-- Without Markups/Flags Option -->
        <div class="link-option">
          <div class="link-option-header">
            <label class="link-label"
              ><span style="color: #265dc3; font-weight: bold">Without</span> markups/flags</label
            >
            <div class="toggle-container">
              <span class="toggle-label">OFF</span>
              <label class="toggle-switch">
                <input
                  type="checkbox"
                  (change)="updateWithoutMarkupsToken()"
                  [(ngModel)]="withoutMarkupsEnabled"
                  [disabled]="processingWithoutMarkups || loading" />
                <span class="toggle-slider"></span>
              </label>
              <span class="toggle-label">ON</span>
            </div>
          </div>
          <div class="link-input-container">
            <input
              type="text"
              class="link-input"
              [value]="getWithoutMarkupsUrl()"
              placeholder="https://gallery_without_markups/flags.com"
              [disabled]="!withoutMarkupsEnabled"
              readonly
              (click)="withoutMarkupsEnabled && copyToClipboard(getWithoutMarkupsUrl(), 'without')" />
            <button
              type="button"
              class="copy-button"
              (click)="copyToClipboard(getWithoutMarkupsUrl(), 'without')"
              [disabled]="!withoutMarkupsEnabled">
              <img src="assets/img/svg/link.svg" alt="Copy" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
